import { createApi } from '@reduxjs/toolkit/query/react';
import { dynamicBaseQuery } from '../badRequestHandler';

// Create the exposure API service
export const exposureApi = createApi({
  reducerPath: 'exposureApi',
  baseQuery: dynamicBaseQuery,
  tagTypes: ['Exposure'],
  endpoints: (builder) => ({
    // Get user exposure bets by userId
    getUserExposureBets: builder.query({
      query: (userId) => ({
        url: `/api/exposure/bets/${userId}`,
        method: 'GET',
      }),
      providesTags: ['Exposure'],
    }),
  }),
});

export const {
  useGetUserExposureBetsQuery,
} = exposureApi;
